import { Stack } from '@mui/material';
import { QuantifyChartWidget } from '../QuantifyChartWidget';
import { QuantifyReportTableWidget } from '../QuantifyReportTableWidget';

export function QuantifyReport() {
  return (
    // (Reason for min-width: 0) https://stackoverflow.com/questions/36230944/prevent-flex-items-from-overflowing-a-container
    <Stack spacing={2} flex={1} sx={{ minWidth: 0 }}>
      <QuantifyChartWidget />
      <QuantifyReportTableWidget />
    </Stack>
  );
}
